import { useState, useEffect } from 'react'
import Icon from '@/components/ui/Icon'
import styles from './OfflineBanner.module.css'

export default function OfflineBanner() {
  const [isOffline, setIsOffline] = useState(!navigator.onLine)

  useEffect(() => {
    const handleOnline = () => setIsOffline(false)
    const handleOffline = () => setIsOffline(true)

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [])

  if (!isOffline) return null

  return (
    <div className={styles.banner}>
      <span className={styles.icon}><Icon name="wifi-off" size={18} /></span>
      <span className={styles.text}>You're offline. Some features may not work.</span>
    </div>
  )
}
